<template>
    <vs-popup fullscreen :active.sync="isSidebarActiveLocal" title="Detayları" v-esc="escape">
      <div class="con-example-prompt content-wrapper" id="temelWrap" v-if="detailData != null">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12" id="" vs-justify="space-between">
          <vs-col vs-type="flex" vs-w="12" class="pl-5 py-5">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" vs-align="center">
                <span class="text-primary bold h4">
                  {{detailData.userWantDto.branchName}} ({{detailData.userWantDto.userName}}) ({{formatDate(detailData.userWantDto.created)}})
                </span>
              </vs-row>
              <!-- <vs-row vs-type="flex" vs-w="12" class="mt-1">
                <span class="h5 w-full weight-600">
                  {{detailData.userWantDto.created}}
                </span>
              </vs-row> -->
              <vs-row vs-type="flex" vs-w="12" class="mt-1">
                <span class="h5 w-full">
                  {{detailData.userWantDto.content}}
                </span>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
        </vs-row>
        <vs-divider color="primary" class="px-5 m-0 my-1" />
        <vs-row id="billContentEntry" vs-type="flex" vs-w="12" vs-justify="space-between"
              v-for="(entry,index) in detailData.entries" :key="index">
              <vs-row :vs-justify="entry.userId != $currentUser.id ?  'flex-start' : 'flex-end'">
  <vs-col type="flex" vs-justify="flex-end" vs-align="center" vs-w="6" style="margin-right: 1rem;">
    <vs-card class="content-card">
      <div slot="header">
        <span>
          {{'('+entry.userName+')'}}
        </span>
      </div>
      <div class="content-wrapper">
        <span>{{ entry.content }}</span>
      </div>
       <div slot="footer">
        <vs-row vs-justify="flex-end">
          <span style="font-size: 0.7rem;">{{(entry.createdText)}}</span>
        </vs-row>
      </div> 
    </vs-card>
  </vs-col>
</vs-row> 
            </vs-row>
      </div>
      <div class="fixed-input">
        <form data-vv-scope="form-1" @keyup.enter="createComment">
          <vs-row vs-type="flex" vs-w="12" id="billFooter" class="px-6" vs-justify="center">
          <vs-col vs-type="flex" vs-w="11" class="pl-5 ">
            <div class="w-full">
            <vs-textarea label="Yorum" name="Yorum" v-validate="'required|min:2'" size="large" v-model="comment"  />
        <!-- <span class="text-danger text-sm" v-show="errors.has('form-1.Yorum')">{{ errors.first('form-1.Yorum')}}</span> -->
      </div>
          </vs-col>
          
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" id="billFooter" class="px-6" vs-justify="center">
          <vs-col vs-type="flex" vs-w="11" class="pl-5">
            <vs-button :disabled="!isCommentValid" size="small" type="gradient" @click="createComment" >Gönder

</vs-button>
          </vs-col>
          
        </vs-row>
        </form>
        
      </div>
      
    </vs-popup>
</template>


<script>
import { getDetail, addComment } from "@/api/UserWant";
import companyInfo from '../../../model/constants/companyInfo';
export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {}
      }
    },
    data(){
      return{
        logo:companyInfo.logo,
        detailData:{},
        comment:'',
        moment: require('moment-timezone')
      }
    } ,
    computed: {
      isCommentValid() {
      return this.comment !== null && this.comment.trim() !== ''
    },
        isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeSidebar");
            this.$validator.reset();
            this.initValues();
          }
        }
      }
    },
    watch: {
      isSidebarActive: function (val) {
        if (!val) return;
        console.log(this.data);
        getDetail(this.data.id).then((res)=>{
            if (res && res.status == 200) {
                console.log(res.data);
                this.detailData = res.data;
                setTimeout(() => {
                      const element = document.getElementById("temelWrap");
                      element.scrollTop = element.scrollHeight;
                    }, 200); // 200 milisaniye (0.2 saniye) bekle
                this.comment=''
            }else{
                this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hata : " + res.status,
              });
            }
        })
        // if (this.data.id == null) {
        //   //this.initValues();
        //   this.$validator.reset();
        // } else {
        //   //this.needUpload = false;
        //   //this.getProductById(this.data.id);
        // }
      }
    },
    methods:{
      formatDate(dateString) {
      return this.moment(dateString).format('DD/MM/YYYY HH:mm')
    },
        escape() {
        this.isSidebarActiveLocal = false;
    },
    createComment: async function () {
      let newComment = {
        userWantId : this.data.id,
        content : this.comment
      }
      let checker;
      checker = await this.$validator.validateAll("form-1");
      if (checker) {
        addComment(newComment).then(res => {
                if (res && res.status == 200) {
                    // this.initNewFormValues();
                    // this.getDatas();
                    this.detailData.entries.push(res.data);
                    setTimeout(() => {
                      const element = document.getElementById("temelWrap");
                      element.scrollTop = element.scrollHeight;
                    }, 200); // 200 milisaniye (0.2 saniye) bekle
                    this.comment = '';
                    this.$vs.notify({
                      color: 'success',
                      title: 'Başarılı !',
                      text: 'Yorumunuz Eklendi '
                    });
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Hata !',
                    text: 'Yasaklı Kullanıcı Ekleme Başarısız ! '
                  });
                }
              }).catch((error) => {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: error.response.data.Errors[0].Message
                });
              });
      }
    }
    }
}
</script>

<style>
  #billReviewerPopup .vs-popup {
    width: 750px !important;
    color: #2B2B2B;
  }

  #billReviewerPopup .vs-popup .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    background: transparent linear-gradient(152deg, #F8F8F8 0%, #F1F1F1 100%) 0% 0% no-repeat padding-box;
  }

  #newBillTotalDiscountType,
  #entryDiscountType {
    min-width: 50px !important;
    background: rgba(var(--vs-primary), 1)
  }

  #bill-logo {
    filter: grayscale(100%);
    opacity: .08;
    height: 175%;
    margin-top: -18px;
  }

  #billHeader {
    height: 6rem;
    background: transparent linear-gradient(117deg, #F8F8F8 0%, #EFEFEF 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 2px 4px #00000026;
    border-radius: 7px;
  }

  #bill-logo-col {
    height: 100%;
    overflow: hidden;
  }

  #billContentHeaderRow {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  #billReviewerPopup .vs-popup .vs-popup--header {
    background: unset !important;
    box-shadow: 0px 2px 4px #00000026;
    border-radius: 7px 7px 0px 0px;
  }

  #billReviewerPopupList {
    height: 50vh;
    overflow-x: auto;
    box-shadow: 0px 2px 4px #00000026;
    border-radius: 7px;
  }

  #billContentEntry .vs-row .vs-list--item .list-titles .vs-list--subtitle {
    margin-left: 10px;
    font-weight: 500;
  }

  #billContentFooter {
    position: absolute;
    bottom: 0;
    right: 5%;
  }

  #billFooter .vs-inputx {
    border: none !important;
    border-bottom: 1px solid #00000035 !important;
    border-radius: 0;
    font-size: 12px;
  }

  #billFooter .vs__dropdown-toggle {
    border: none;
    border-bottom: 1px solid #00000035;
    border-radius: 0;
    font-size: 12px;
  }

  .fixed-input {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  z-index: 1000;
}
  </style>
<style scoped>
.content-wrapper {
  max-height: calc(100vh - 250px); /* fixed-input bölümünün yüksekliğine göre ayarlayın */
  overflow-y: auto;
}
</style>
<style scoped>

.content-wrapper {
  word-wrap: break-word; /* İçeriğin alt satıra inmesini sağlar */
}
</style>